module.exports = __webpack_public_path__ + "images/help_v2/masthead_roadmap-41830cdc81423b57150a4137f177f79d.png";